export class TicketUserType{
    id:number;
    name:string;
    ticketUserId:number;
    ticketId:number;
    userId:number;
    userName:string;
    imageURL:string;
}